import { MAX_BUILDING_LEVEL } from 'constants'
import { canManageBuilding } from './accounts.js'

export function checkIndustrialResource(state) {
    const upgradeCost = state.settings.command_center.costs[state.stronghold.level]
    const industrialResourceBalance = state.clan.industrial_resource
    return (industrialResourceBalance >= upgradeCost)
}

export function checkUpgradeVisibility(state) {
    const hasPermission = canManageBuilding(state.account)
    const maxLevelReached = (state.stronghold.level === MAX_BUILDING_LEVEL)
    return (hasPermission && !maxLevelReached)
}

export function getNecessaryBuildingsLevel({ settings, stronghold }) {
    return settings.command_center.required_total_stronghold_level_to_upgrade[stronghold.level - 1]
}

export function getBuildingsLevelSumm({ stronghold, buildings }) {
    let levelsSumm = stronghold.level
    for (let buildingId of Object.keys(buildings)) {
        levelsSumm += buildings[buildingId].level
    }

    return levelsSumm
}

export function checkBuildingsLevelSumm(state) {
    const necessaryBuildingsLevel = getNecessaryBuildingsLevel(state)
    const buildingsLevelSumm = getBuildingsLevelSumm(state)

    return buildingsLevelSumm >= necessaryBuildingsLevel
}

export function upgradeAvailability(state) {
    const hasEnougthIndustrialResource = checkIndustrialResource(state)
    const showUpgrade = checkUpgradeVisibility(state)
    const hasEnoughBuildingLevelSumm = checkBuildingsLevelSumm(state)

    return (hasEnoughBuildingLevelSumm && hasEnougthIndustrialResource && showUpgrade)
}



// WEBPACK FOOTER //
// ./helpers/stronghold.js